import { LEGACY_COURSE_ID, useCourses } from 'hooks/useCourses';
import { GenericTopicPage } from 'pages/online-trainings/generic-topic';
import { OldHandHygieneTopic } from 'pages/online-trainings-old/hand-hygiene/topic';
import { useParams } from 'react-router-dom';

export const SmartTopicPage = () => {
    const { coursePath } = useParams<{ coursePath: string }>();
    const { allCoursesData, isLoadingCourses } = useCourses();

    if (isLoadingCourses) return null;

    const course = allCoursesData.find((c) => c.path === coursePath);

    if (course?.id === LEGACY_COURSE_ID) {
        return <OldHandHygieneTopic />;
    }

    return <GenericTopicPage />;
};
